import { IPayIn } from "@rentiohq/shared-frontend/dist/types/payin.types";

export const getActivitiesFilter = (payIn: IPayIn) => {
  const { id } = payIn;

  return {
    where: { paymentPayInId: id },
  };
};
